export default __webpack_public_path__ + "static/media/flips_empty_2025.289cd3b5.png";